import React, { FC } from 'react';
import { useLanguage } from '../i18n';

export const CountriesDatalist: FC<{ id: string }> = ({ id }) => {
    const lang = useLanguage();
    const countries: string[] = lang === 'en' ? countriesEn : countriesNb;

    return (
        <datalist id={id}>
            {countries.map(country => (
                <option key={country} value={country} />
            ))}
        </datalist>
    );
};

export const countriesNb = [
    'Afghanistan',
    'Akrotiri',
    'Albania',
    'Algerie',
    'Amerikansk Samoa',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antigua og Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Aserbajdsjan',
    'Australia',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belgia',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia',
    'Bosnia-Hercegovina',
    'Botswana',
    'Brasil',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burma',
    'Burundi',
    'Canada',
    'Caymanøyene',
    'Chile',
    'Christmasøya',
    'Colombia',
    'Cookøyene',
    'Costa Rica',
    'Cuba',
    'Danmark',
    'De amerikanske Jomfruøyer',
    'De britiske Jomfruøyer',
    'De forente arabiske emirater',
    'De nederlandske Antiller',
    'Den demokratiske republikken Kongo',
    'Den dominikanske republikk',
    'Den sentralafrikanske republikk',
    'Dhekelia',
    'Djibouti',
    'Dominica',
    'EU',
    'Ecuador',
    'Egypt',
    'Ekvatorial-Guinea',
    'El Salvador',
    'Elfenbenskysten',
    'Eritrea',
    'Estland',
    'Etiopia',
    'Falklandsøyene',
    'Fiji',
    'Filippinene',
    'Finland',
    'Frankrike',
    'Fransk Polynesia',
    'Færøyene',
    'Gabon',
    'Gambia',
    'Gaza',
    'Georgia',
    'Ghana',
    'Gibraltar',
    'Grenada',
    'Grønland',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Hellas',
    'Honduras',
    'Hongkong',
    'Hviterussland',
    'India',
    'Indonesia',
    'Irak',
    'Iran',
    'Irland',
    'Island',
    'Israel',
    'Italia',
    'Jamaica',
    'Japan',
    'Jemen',
    'Jersey',
    'Jordan',
    'Kambodsja',
    'Kamerun',
    'Kapp Verde',
    'Kasakhstan',
    'Kenya',
    'Kina',
    'Kirgisistan',
    'Kiribati',
    'Kokosøyene',
    'Komorene',
    'Kosovo',
    'Kroatia',
    'Kuwait',
    'Kypros',
    'Laos',
    'Latvia',
    'Lesotho',
    'Libanon',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Litauen',
    'Luxembourg',
    'Macao',
    'Madagaskar',
    'Malawi',
    'Malaysia',
    'Maldivene',
    'Mali',
    'Malta',
    'Man',
    'Marokko',
    'Marshalløyene',
    'Mauritania',
    'Mauritius',
    'Mayotte',
    'Mexico',
    'Mikronesiaføderasjonen',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Mosambik',
    'Namibia',
    'Nauru',
    'Nederland',
    'Nepal',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Niue',
    'Nord-Korea',
    'Nord-Makedonia',
    'Nord-Marianene',
    'Norfolkøya',
    'Norge',
    'Ny-Caledonia',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestina',
    'Panama',
    'Papua Ny-Guinea',
    'Paraguay',
    'Peru',
    'Pitcairnøyene',
    'Polen',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Republikken Kina (Taiwan) (Taiwan)',
    'Republikken Kongo',
    'Romania',
    'Russland',
    'Rwanda',
    'Saint Kitts og Nevis',
    'Saint Lucia',
    'Saint Martin',
    'Saint Vincent og Grenadinene',
    'Saint-Barthélemy',
    'Saint-Pierre og Miquelon',
    'Salomonøyene',
    'Samoa',
    'San Marino',
    'Saudi-Arabia',
    'Senegal',
    'Serbia',
    'Seychellene',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Somalia',
    'Spania',
    'Sri Lanka',
    'St. Helena',
    'Storbritannia',
    'Sudan',
    'Surinam',
    'Sveits',
    'Sverige',
    'Swaziland',
    'Syria',
    'São Tomé og Príncipe',
    'Sør-Afrika',
    'Sør-Korea',
    'Sør-Sudan',
    'Tadsjikistan',
    'Tanzania',
    'Thailand',
    'Togo',
    'Tokelau',
    'Tonga',
    'Trinidad og Tobago',
    'Tsjad',
    'Tsjekkia',
    'Tunisia',
    'Turkmenistan',
    'Turks- og Caicosøyene',
    'Tuvalu',
    'Tyrkia',
    'Tyskland',
    'USA',
    'Uganda',
    'Ukraina',
    'Ungarn',
    'Uruguay',
    'Usbekistan',
    'Vanuatu',
    'Vatikanstaten',
    'Venezuela',
    'Vest-Sahara',
    'Vietnam',
    'Wallis og Futuna',
    'Zambia',
    'Zimbabwe',
    'Øst-Timor',
    'Østerrike',
];

export const countriesEn = [
    'Afghanistan',
    'Albania',
    'Algeria',
    'Andorra',
    'Angola',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bhutan',
    'Bolivia',
    'Bosnia and Herzegovina',
    'Botswana',
    'Brazil',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cabo Verde',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Colombia',
    'Comoros',
    'Congo (Congo-Brazzaville)',
    'Costa Rica',
    'Croatia',
    'Cuba',
    'Cyprus',
    'Czechia (Czech Republic)',
    "Côte d'Ivoire",
    'Democratic Republic of the Congo',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Eswatini',
    'Ethiopia',
    'Fiji',
    'Finland',
    'France',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Greece',
    'Grenada',
    'Guatemala',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Holy See',
    'Honduras',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Mauritania',
    'Mauritius',
    'Mexico',
    'Micronesia',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Morocco',
    'Mozambique',
    'Myanmar',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'North Korea',
    'North Macedonia',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestine State',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Qatar',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Vincent and the Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Korea',
    'South Sudan',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Sweden',
    'Switzerland',
    'Syria',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Timor-Leste',
    'Togo',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'United States of America',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Venezuela',
    'Vietnam',
    'Yemen',
    'Zambia',
    'Zimbabwe',
];
